import { useLanguageStore } from "src/store/languageStore";
import ImageButton from "./image-button";
import { useNavigationStore } from "@/store/navigationStore";
import { useExplorationStore } from "@/store/explorationStore";
import Image from "src/components/image";

export default function XrayButton({ mode }: { mode: string }) {
  const NavigationXrayButton = () => {
    const xRayMode = useNavigationStore((state) => state.xRayMode);
    const switchXRayMode = useNavigationStore((state) => state.switchXRayMode);
    return xRayMode > 0 ? (
      <ImageButton
        className="button-glass-blur"
        src={
          xRayMode == 1
            ? "/assets/icon_xRay_off.png"
            : "/assets/icon_xRay_on.png"
        }
        onClick={() => switchXRayMode()}
        alt="rotate icon"
        size={32}
      />
    ) : (
      <></>
    );
  };

  const ExplorationXrayButton = () => {
    const xRayMode = useExplorationStore((state) => state.xRayMode);
    const switchXRayMode = useExplorationStore((state) => state.switchXRayMode);
    return xRayMode > 0 ? (
      <ImageButton
        className="button-glass-blur"
        src={
          xRayMode == 1
            ? "/assets/icon_xRay_off.png"
            : "/assets/icon_xRay_on.png"
        }
        onClick={() => switchXRayMode()}
        alt="rotate icon"
        size={32}
      />
    ) : (
      <></>
    );
  };

  return mode == "navigation" ? (
    <NavigationXrayButton />
  ) : mode == "exploration" ? (
    <ExplorationXrayButton />
  ) : (
    <></>
  );
}
